<template>
  <v-flex>
    <!-- Explanation -->
    <p class="headline font-weight-medium text-uppercase font-italic py-0 my-0" style="color:#C7A754"> Per Month
      Breakdown </p>
    <v-data-table v-model="selectedData" :headers="headers" :items="availableData" :single-select="false"
      hide-default-footer class="elevation-1">
    </v-data-table>
  </v-flex>
</template>


<script>
import utils from '@/utils';

export default {
  props: ["year", "rawData"],
  data: () => ({
    //------------------- Data Table Items ------------------------- //
    singleSelect: false,
    selectedData: [],
    headers: [
      { text: 'Category', value: 'label' },
      { text: 'Jan', value: 'Jan' },
      { text: 'Feb', value: 'Feb' },
      { text: 'Mar', value: 'Mar' },
      { text: 'Apr', value: 'Apr' },
      { text: 'May', value: 'May' },
      { text: 'Jun', value: 'Jun' },
      { text: 'Jul', value: 'Jul' },
      { text: 'Aug', value: 'Aug' },
      { text: 'Sep', value: 'Sep' },
      { text: 'Oct', value: 'Oct' },
      { text: 'Nov', value: 'Nov' },
      { text: 'Dec', value: 'Dec' },
    ],
  }),
  mounted() {
    console.log('KBEUI Raw Data Structure:', this.rawData);
    console.log('Available fields:', this.rawData ? Object.keys(this.rawData) : 'No data available');
  },
  computed: {
    availableData() {
      let arr = []
      if (!this.rawData) {
        return arr;
      }
      let yearString = this.year
      if (this.$store.state.KBEUI.unit == 'SI') {
        arr.push(this.parseRow('EUI (kWh/m^2)', 'EUI_kWh_m2', 3.412 / 10.7639))
        arr.push(this.parseRow('BTL (kWh)', 'Building_Load_kWh', 3.412))
        arr.push(this.parseRow('PV (kWh)', 'Total_PVgen_kWh', 3.412, -1))
        arr.push(this.parseRow('ER', 'Energy_Ratio'))
        arr.push(this.parseRow('ERMA', 'ERMA'))
        arr.push(this.parseRow('EUIMA (kWh/m^2)', 'EUIMA', 3.412 / 10.7639))
      } else {
        arr.push(this.parseRow('EUI (kBTU/sqft)', 'EUI_kWh_m2', 3.412 / 10.7639))
        arr.push(this.parseRow('BTL (kBTU)', 'Building_Load_kWh', 3.412))
        arr.push(this.parseRow('PV (kBTU)', 'Total_PVgen_kWh', 3.412, -1))
        arr.push(this.parseRow('ER', 'Energy_Ratio'))
        arr.push(this.parseRow('ERMA', 'ERMA'))
        arr.push(this.parseRow('EUIMA (kBTU/sqft)', 'EUIMA', 3.412 / 10.7639))
      }

      this.headers = [{ text: 'Category', value: 'label' }].concat(Object.keys(arr[0]).filter(x => x != 'label').map(x => { return { text: x, value: x } }))
      return arr;
    },
    dataArray() { 
      // even though the main component calculated dataArray already,
      // we create our own dataArray to prevent race conditions since both are updated almost simultaneously
      return utils.processData(this.rawData);
    },
    total() {
      let mult
      if (this.$store.state.KBEUI.unit == 'SI') {
        mult = 1
      } else {
        mult = 3.412
      }
      console.log('total'); return this.dataArray.map(function (value, index) { return (value[4] * mult).toFixed(2) })
    },
    EUI() {
      let ind
      if (this.$store.state.KBEUI.unit == 'SI') {
        ind = 5
      } else {
        ind = 6
      }
      console.log('EUI'); return this.dataArray.map(function (value, index) { return (value[ind]).toFixed(2) })
    },
    energy_ratio() {
      console.log('energy ratio'); return this.dataArray.map(function (value, index) { return (value[7]).toFixed(2) })
    },
    ERMA() {
      console.log('erma'); return this.dataArray.map(function (value, index) { return (value[8]).toFixed(2) })
    },
    EUIMA() {
      let mult
      if (this.$store.state.KBEUI.unit == 'SI') {
        mult = 1
      } else {
        mult = 3.412 / 10.7639
      }
      console.log('euima'); return this.dataArray.map(function (value, index) { return (value[9] * mult).toFixed(2) })
    },

  },
  methods: {
    genObj(lbl, data) {
      let obj =
      {
        label: lbl,
        Jan: data[0],
        Feb: data[1],
        Mar: data[2],
        Apr: data[3],
        May: data[4],
        Jun: data[5],
        Jul: data[6],
        Aug: data[7],
        Sep: data[8],
        Oct: data[9],
        Nov: data[10],
        Dec: data[11],
      }
      return obj
    },
    parseRow(lbl, field, multiplier = null, valueModifier = 1) {
      let obj = {
        label: lbl,
      }
      let year = 20
      let count = 0
      let yearString = this.year
      for (let i = 0; i < this.rawData['Date'].length; i++) {
        let date = this.rawData['Date'][i]
        let yearStringKey = ''
        if (yearString == 'all') {
          yearStringKey = date + (year + parseInt(count / 12))
        } else {
          yearStringKey = date
        }
        if (multiplier && this.$store.state.KBEUI.unit != 'SI') {
          obj[yearStringKey] = this.rawData[field] ? (this.rawData[field][i] * multiplier * valueModifier).toFixed(2) : ''
        } else {
          obj[yearStringKey] = this.rawData[field] ? (this.rawData[field][i] * valueModifier).toFixed(2) : ''
        }
        count++
      }
      return obj
    }
  },
}
</script>

